module.exports = __webpack_public_path__ + "static/flowers-a196b70b4ddb0f7873e3c6e8e8b58dba.png";